import clsx from 'clsx';
import { useMemo } from 'react';

import { useQueryState } from '@/hooks/useQueryState';
import { useTradeStore } from '@/store/trade-store';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';
import HistoryOrders from './history-orders/history-orders';
import PositionOrders from './position-orders/position-orders';
import { PanelType } from './type';

type StateQuery = {
    tab: PanelType;
};

const currentState = {
    tab: PanelType.Position,
};

export function TradingPanelOrder() {
    const { t } = useTranslation();

    const { state, setQueryState } = useQueryState<StateQuery>(currentState);

    const { count } = useTradeStore(
        useShallow((state) => ({
            count: state.count,
        }))
    );

    const tabs = useMemo(() => {
        return [
            {
                title: 'Positions',
                value: PanelType.Position,
                component: <PositionOrders />,
                numbers: count.openTrade,
            },

            {
                title: 'History',
                value: PanelType.History,
                component: <HistoryOrders />,
                numbers: 0,
            },
        ].filter(Boolean);
    }, [count.openTrade]);

    return (
        <div className="relative bg-[#f7f9fc] min-h-dvh">
            <div className="px-4 pt-6 pb-2 sticky top-0 z-20 backdrop-blur-sm">
                <div className="flex gap-6 border-b border-[#e5e7eb]">
                    {tabs.map((item) => {
                        return (
                            <button
                                key={item.value}
                                onClick={() => {
                                    setQueryState({ tab: item.value });
                                }}
                                className={clsx(
                                    'pb-3 border-b-2  text-base transition-colors',
                                    {
                                        'border-transparent':
                                            state.tab !== item.value,
                                        'border-[#1a1d1f] font-bold':
                                            state.tab == item.value,
                                    }
                                )}
                            >
                                <span
                                    className={clsx({
                                        'text-black': state.tab === item.value,
                                        'text-[#6f767e]':
                                            state.tab !== item.value,
                                    })}
                                >
                                    {t(item.title)}{' '}
                                    {item.numbers !== 0
                                        ? ` (${item.numbers})`
                                        : ''}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>

            {tabs.find((item) => item?.value === state.tab)?.component}
        </div>
    );
}
